module.exports = __webpack_public_path__ + "img/311.0e990b6a.png";